import React, { useEffect, useState } from "react";
import { getAllDeliveryRequest } from "../../../utilities";
import WidgetFrame, { WidgetEmpty } from "./WidgetFrame";

// The Request Manager endpoint returns only open requests, so every row is
// awaiting review. Newest are last in the raw array (the page reverses).
const RequestManagerWidget = () => {
  const [requests, setRequests] = useState(null);

  useEffect(() => {
    getAllDeliveryRequest((data) =>
      setRequests(Array.isArray(data) ? data : [])
    );
  }, []);

  if (!requests) {
    return (
      <WidgetFrame title="Request Manager" to="/windowdoor/admin/requestlist">
        <WidgetEmpty>Loading open requests…</WidgetEmpty>
      </WidgetFrame>
    );
  }

  const recent = requests.slice(-3).reverse();

  return (
    <WidgetFrame title="Request Manager" to="/windowdoor/admin/requestlist">
      <p className="flex items-baseline gap-1.5 text-sm">
        <span className="text-2xl font-semibold tabular-nums tracking-tight">{requests.length}</span>{" "}
        <span className="app-muted">awaiting review</span>
      </p>
      {recent.length > 0 ? (
        <ul className="mt-2.5 space-y-1.5">
          {recent.map((request) => (
            <li
              key={request._id}
              className="flex items-center justify-between gap-2 text-sm"
            >
              <span className="truncate font-medium">
                {request.salesOrder || "No order #"}
              </span>
              <span className="app-muted shrink-0 text-xs">
                {request.requestName}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <WidgetEmpty>Nothing waiting — nice.</WidgetEmpty>
      )}
    </WidgetFrame>
  );
};

export default RequestManagerWidget;
